<template lang="pug">
  v-container
    v-row(justify="center")
      v-col(
        cols="12"
        md="11"
      )
        h2 {{ displayTextCount }}.
    v-row(justify="center")
      v-col(
        cols="12"
        md="11"
      )
        v-row.mx-0
          v-card(flat)
            v-tabs(v-model="tab")
              v-tab(
                v-for="(tab, i) in tabs"
                :key="i"
                @click="reloadData()"
              )
                v-chip(
                  pill
                  :input-value="true"
                  style="cursor: pointer;"
                )
                  v-avatar(left).primary.white--text {{ !!i ? publishedCount : unpublishedCount }}
                  | {{ tab }}
              //- ({{ !!i ? publishedCount : unpublishedCount }})
                
              v-spacer

              v-btn(
                style="text-transform: none; margin-top: 6px; margin-right: 6px;"
                color="primary"
                :to="{ name: 'addscholar' }"
              )
                v-icon(left) mdi-plus 
                span Add A Scholar
            v-col(cols="12")
              v-row.mx-0
                v-col(cols="12").py-0
                  v-divider.mb-2

                  h3(v-if="tab===0") Scholars in the unpublished tab mean that they are not to be shown yet in the Mighty Minds Website. Publish a scholar if you are ready to show them on the site for crowdfunding.
                  h3(v-else) Scholars are ready for crowdfunding once published. Kindly unpublish them if they already got the required funding.

                v-col(
                  cols="12"
                  sm="6"
                ).py-0
                  v-text-field(
                      label="Search scholars"
                      append-icon="mdi-magnify"
                      single-line
                      outlined
                      v-model="keyword"
                      @input="find()"
                      hide-details
                    ).my-3
                v-col(cols="12").py-0
                  v-divider
              
              v-tabs-items(v-model="tab")
                v-tab-item(
                  v-for="(item, index) in beneficiaryList",
                  :key="index"
                )
                  v-col(cols="12").pt-0
                    scholar-table(
                      :beneficiaryList="item"
                      :isUnpublishedTab="!!tab"
                      @reload="handleEmit"
                    )
</template>

<script>
import ScholarTable from '@/components/scholar/ScholarTable';

export default {
  components: {
    ScholarTable
  },
  data: () => ({
    tab: null,
    tabs: [ 'Unpublished', 'Published' ],
    keyword: '',
    publishedBeneficiaries: 0,
    unpublishedList: null,
    publishedList: null,
    unpublishedCount: 0,
    publishedCount: 0
  }),
  computed: {
    displayTextCount () {
      const count = this.publishedCount;
      return `You have ${count} published ${count > 0 ? 'scholars' : 'scholar'}`;
    },
    beneficiaryList () {
      return [this.unpublishedList, this.publishedList];
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    async loadData () {
      try {
        this.$setLoading(true);
        await this.$store.dispatch('beneficiaries/getList', { organization: this.$route.params.id });
        // await this.$store.dispatch('beneficiaries/testGet');
        this.reloadData();
      } catch (error) {
        console.log(error);
      }
      this.$setLoading(false);
    },
    async reloadData () {
      try {
        this.$setLoading(true);
        this.unpublishedList = await this.$store.dispatch('beneficiaries/getListByPublishStatus', { published: false });
        this.publishedList = await this.$store.dispatch('beneficiaries/getListByPublishStatus', { published: true });
        this.unpublishedCount = this.unpublishedList.length;
        this.publishedCount = this.publishedList.length;
        this.keyword = '';
      } catch (error) {
        console.log(error);
      }
      this.$setLoading(false);
    },
    async find () {
      try {
        if (this.tab === 1) {
          this.publishedList = await this.$store.dispatch('beneficiaries/getListByPublishStatus', { published: true, keyword: this.keyword });
          this.unpublishedList = await this.$store.dispatch('beneficiaries/getListByPublishStatus', { published: false });
        } else {
          this.unpublishedList = await this.$store.dispatch('beneficiaries/getListByPublishStatus', { published: false, keyword: this.keyword });
          this.publishedList = await this.$store.dispatch('beneficiaries/getListByPublishStatus', { published: true });
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleEmit () {
      this.reloadData();
    }
  }
};
</script>